import { CrmDictionary } from 'common-module/core/types';
import { CrmEndpointListResponse } from 'common-module/endpoint';
import { CrmUserEndpoint } from 'common-module/user';
import { map, Observable } from 'rxjs';

import { UserModel } from './user.model';

export class UserEndpoint extends CrmUserEndpoint<UserModel> {
  override list(options?: CrmDictionary): Observable<CrmEndpointListResponse<UserModel>> {
    return this.client
      .get<CrmEndpointListResponse<UserModel>>(`${this.endpoint({})}`, this.getReqOptions(options))
      .pipe(
        map((response) => {
          return {
            ...response,
            data: response.data.map(this.responseTransformer.transform),
          };
        }),
      );
  }
}
